import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'

import InsuranceCompanySearch from '../../components/insuranceCompany/InsuranceCompanySelector/search'
import * as insuranceCompanySelectors from '../../redux/insuranceCompanies/selectors'
import * as insuranceCompanyActions from '../../redux/insuranceCompanies/actions'

const InsuranceCompanySelectorContainer = ({
  dispatchGetAllInsuranceCompanies,
  dispatchAddInsuranceCompany,
  handleChange,
  insuranceCompanies,
  value: valueId,
  excludeId,
  allowCreate = true,
  label,
  name,
}) => {
  const [optionSelected, setOptionSelected] = React.useState(null)

  React.useEffect(() => {
    dispatchGetAllInsuranceCompanies()
  }, [])

  const searchInsuranceCompanyById = (id) => insuranceCompanies.valueSeq()
    .find(company => company.get('_id') === id)

  React.useEffect(() => {
    if (!valueId) {
      setOptionSelected(null)
      return
    }
    if (!optionSelected || optionSelected.value !== valueId) {
      const company = searchInsuranceCompanyById(valueId)
      if (company) {
        setOptionSelected({ label: company.get('name'), value: company.get('_id') })
      }
    }
  }, [valueId, insuranceCompanies])

  const onChange = (event) => {
    const { value } = event.target
    if (!value) {
      setOptionSelected(null)
    } else {
      const company = searchInsuranceCompanyById(value)
      if (company) {
        setOptionSelected({ label: company.get('name'), value: company.get('_id') })
      }
    }
    handleChange(event)
  }

  const onCreateOption = (inputValue) => dispatchAddInsuranceCompany({ name: inputValue })
    .then((normalized) => {
      const id = normalized.result
      const company = normalized.entities.insuranceCompany[id]
      const option = { value: id, label: company.name }
      setOptionSelected(option)
      handleChange({ target: { name: name || 'insuranceCompany', value: id } })
    })

  return (
    <InsuranceCompanySearch
      value={optionSelected}
      handleChange={onChange}
      onCreateOption={allowCreate ? onCreateOption : undefined}
      insuranceCompanies={insuranceCompanies}
      excludeId={excludeId}
      allowCreate={allowCreate}
      label={label}
      name={name}
    />
  )
}

InsuranceCompanySelectorContainer.propTypes = {
  insuranceCompanies: ImmutablePropTypes.map,
  dispatchGetAllInsuranceCompanies: PropTypes.func.isRequired,
  dispatchAddInsuranceCompany: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  excludeId: PropTypes.string,
  allowCreate: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
}

const mapStateToProps = (state) => ({
  insuranceCompanies: insuranceCompanySelectors.getAll(state),
})

const mapDispatchToProps = (dispatch) => ({
  dispatchGetAllInsuranceCompanies: () => dispatch(insuranceCompanyActions.getAll()),
  dispatchAddInsuranceCompany: (data) => dispatch(insuranceCompanyActions.add(data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(InsuranceCompanySelectorContainer)
